import cloneDeepWith from "lodash/cloneDeepWith";
import isPlainObject from "lodash/isPlainObject";

const tokenReferenceRegex = /\{([a-zA-Z0-9._-]+)\}/g;

const toCssVarName = (reference: string) => `--${reference.replaceAll(".", "-").replaceAll("_", "-")}`;

const normalizeTokenValue = (value: unknown) => {
    if (typeof value !== "string") {
        return value;
    }
    return value.replaceAll(tokenReferenceRegex, (_match, reference: string) => {
        const normalizedReference = reference.endsWith(".value") ? reference.slice(0, -".value".length) : reference;

        return `var(${toCssVarName(normalizedReference)})`;
    });
};

export function filterTokens(tokens: Record<string, unknown>, prefix: string) {
    return Object.fromEntries(
        Object.entries(tokens)
            .filter(([key]) => key.startsWith(prefix))
            .map(([key, value]) => [key.replace(`${prefix}-`, ""), value])
    );
}

export const flattenValues = (object: Record<string, unknown>) =>
    cloneDeepWith(object, node => {
        // If we encounter an object with a "value" key, return just that value
        if (isPlainObject(node) && "value" in node) {
            return normalizeTokenValue(node.value);
        }
        // Otherwise, returning undefined tells lodash to keep recursing normally
        return undefined;
    });
